import script from "./AiConfigurator.vue?vue&type=script&setup=true&lang=js"
export * from "./AiConfigurator.vue?vue&type=script&setup=true&lang=js"

import "./AiConfigurator.vue?vue&type=style&index=0&id=382dca40&scoped=true&lang=css"

import exportComponent from "/Users/marcin/Local Sites/ovalia/app/public/wp-content/themes/ovalia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-382dca40"]])

export default __exports__